module.exports = __webpack_public_path__ + "img/loadar.6961a939.svg";